import { createAsyncThunk } from "@reduxjs/toolkit";
import sessionService from "@/shared/services/api/session-service";

// Tüm oturumları getir
export const getSessions = createAsyncThunk(
  "session/getSessions",
  async (_, thunkAPI) => {
    try {
      const response = await sessionService.getSessions();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
);

// Belirli bir oturumu sil ve sonrasında session listesini yenile
export const deleteSession = createAsyncThunk(
  "session/deleteSession",
  async (sessionId: string, thunkAPI) => {
    try {
      const response = await sessionService.deleteSession(sessionId);
      
      // Silme işlemi başarılıysa session listesini yenile
      if (response.success) {
        await thunkAPI.dispatch(getSessions());
      }
      
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
);

// Tüm oturumları sonlandır ve sonrasında session listesini yenile
export const terminateAllSessions = createAsyncThunk(
  "session/terminateAllSessions",
  async (_, thunkAPI) => {
    try {
      const response = await sessionService.terminateAllSessions();
      
      // Sonlandırma işlemi başarılıysa session listesini yenile
      if (response.success) {
        await thunkAPI.dispatch(getSessions());
      }
      
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
); 